<template>
  <div class="hide-on-md hide-on-print mt-5 abs-left-0">
    <v-container fluid class="fixed-buttons mt-0 px-0">
      <v-layout row>
        <v-flex xs6 md2 class="px-5 py-3">
          <v-btn
            block
            depressed
            color="primary"
            @click="search"
          >
            Search
          </v-btn>
        </v-flex>
        <v-flex xs6 md2 class="px-3 py-3" :class="{ 'pl-3' : $vuetify.breakpoint.mdAndUp }">
          <v-btn
            color="black"
            block
            outlined
            depressed
            @click="clear"
          >Clear</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: [
    'isFormValid'
  ],
  methods: {
    search () {
      this.$emit('search')
    },
    clear () {
      this.$emit('clear')
    }
  }
}
</script>
